<template>
  <modal
    :name="modalName"
    resizable adaptive
    draggable=".window-header"
    @opened="opened"
    width="900"
    height="auto"
    :scrollable="false"
  >
    <!-- height="470" -->
    <!-- https://github.com/euvl/vue-js-modal -->

    <!-- 날짜 기준으로 유효한 회원을 검색한다. -->

    <h5 class="pop_tit window-header">회원 검색 <small>( 기준일 : {{ search.cntchargdt }} )</small> <span class="pop_close" @click="doClose"></span></h5>
    <div class="popup_wrap">
      <div class="btn_group mt-10">
        <div class="left">
          * 컨트롤(CTRL) 키를 누른 상태로 여러 회원을 클릭하면 다중 선택이 가능합니다.
        </div>
        <div class="right">
          <a @click="doSearch('검색버튼')"  class="btn icon search_black ">검색</a>
          <a @click="doInit"  class="btn icon reload ">초기화</a>
        </div>
      </div>

      <table class="tbl01 sch_tbl">
        <tr>
          <th>회원명</th>
          <td>
            <i-input ref="kword" placeholder="회원명" v-model="search.kword" @keyup.enter="doSearch('상단입력_엔터')"/>
            <!-- <label><input type="checkbox" v-model="search.ableyn" true-value="Y" false-value="" class="ml10"/> 추가가능 회원만</label> -->
            <!-- <template v-if="['master', 'member'].includes($store.state.session.user.type)">
              <label><input type="checkbox" v-model="search.memberyn" true-value="Y" false-value="" class="ml10"/> 소속변호사</label>
            </template> -->
          </td>
        </tr>
      <!--
        <tr>
          <th>구입일자</th>
          <td>
            <input class="w_inputno" placeholder="2010011" />
            ~ <input class="w_inputno" placeholder="2010011"/> </td>
        </tr>
        <tr>
          <th>증표 명의</th>
          <td><input class="sch_input" title="구입 명의자" name="" value="" placeholder="구입 명의자" /> </td>
        </tr>
        <tr>
          <th>증표 종류</th>
          <td>
              <input type="checkbox" name="" valeu="" id="s_0" /> <label for="s_0">전체</label>
              <input type="checkbox" name="" valeu="" id="s_1" /> <label for="s_1">입금대기</label>
              <input type="checkbox" name="" valeu="" id="s_2" /> <label for="s_2">미입금 취소</label>
              <input type="checkbox" name="" valeu="" id="s_3" /> <label for="s_3">금액 불일치</label> ( 상태 필요에 따라 더추가하세요..)
          </td>
        </tr>
        <tr>
          <th>증표 번호</th>
          <td><input type="text" class="sch_input" title="구입 명의자" name="" value="" placeholder="증표번호" /></td>
        </tr>
        -->
      </table>
        <!-- <s-table3
          ref        = "main"
          :list.sync = "list"
          @itemClick = "doClick"
          @loadData  = "getDataList"
        /> -->

      <div width="100%">
        <s-loading v-if="detail_loading"/>
        <div class="scroll_wrap"> <!--모바일 스크롤 -->
          <p class="scroll_txt"> &lt;-&gt; 좌우 스크롤을 이용하세요</p>

          <table class="tbl01 th_gray v-data-table memb_select">
            <thead>
              <tr>
                <th width="150">회원명  </th>
                <th width="70">등록번호</th>
                <th width="70">생년월일</th>
                <th>소속    </th>
                <th v-if="!forceSelect" width="90">추가가능여부</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in list.items" :key="'tr1_'+i"
                @click="doClick(item,$event)"
                :class="{
                  selected: _.some(memblist, { membclsf: item.membclsf, membno: item.membno }),
                  error: !forceSelect && item.memb_status != 'OK',
                }"
                >
                <td>{{ item.membnm     }}</td>
                <td>{{ item.membno     }}</td>
                <td>{{ item.birthday     }}</td>
                <td>{{ item.blngmembnm }}</td>
                <td v-if="!forceSelect">{{ item.memb_status != 'OK' ? '불가' : '가능' }}</td>
              </tr>
              <!-- 빈칸 체우기 -->
              <tr v-for="i in (list.items ? Math.max((list.pageSize - list.items.length),0) : list.pageSize)" :key="'tr2_'+i">
                <td v-for="j in 4" :key="'td1_'+j"></td>
              </tr>
            </tbody>
          </table>
        </div> <!--// scroll_wrap -->

        <div class="s-tbl-footer-wrap">
          <div class="s-tbl-footer-center text-xs-center">
            <s-page v-if="totPages && totPages > 1"
                    v-model="list.pageNo"
                    :length="totPages"
                    style="padding:0; margin:0;"
                    :total-visible="10"
                    @changePage="getDataList"
              />
          </div>
          <div v-if="list.totalCount && list.totalCount >= 0" class="s-tbl-footer-left">
              총 {{ list.totalCount | comma }}명
          </div>
          <div class="s-tbl-footer-right">
              페이지당 줄 수
                <i-input-sel style="width: 60px;"
                  v-model="list.pageSize"
                  :items="[10,15,20,30,40,50,70,100,200,500,1000,2000,10000]"
                  @input=getDataList
                />
          </div>
        </div>

      </div>

    </div>

  </modal>
</template>

<script>
import { fail } from 'assert';
let ui, _
const isDebug = true
export default {
  // props: ['name'],
  props : {
    memblist: {
        type: Array,
        default: ()=>[],
    },
  },
  data () {
    return {
      detail_loading: false,
      modalName: "c회원선택2_" + T.randomAZ(10),
      defaultKword: null,
      caseGubun:null,
      search: { // 검색 변수
        kword  : '',
        memberyn : '',
        ableyn: '',
      },
      // 목록 전용 변수
      // totpages: 0,
      list: {
        loading: false,
        pageSize: 10,
        totalCount: 0,
      },
      list_init: {
        loading: false,
        pageSize: 10,
        pageNo: 1,
        totalCount: 0,
/*         headers: T.makeJson(`
          value      | text         | width  | align
          membnm     | 회원명       | 150    |
          membno     | 등록번호     | 70     | center
          blngmembnm | 소속         |        | right
        `), */
      },
      searchMode: '',
      forceSelect: false, // 무조건 선택가능
    }
  },
  computed: {
    totPages() { // 총 페이지 수 계산
      return Math.ceil(this.list.totalCount / this.list.pageSize)
    },
    org_mode() {
      return ['master', 'member'].includes(this.$store.state.session.user.type)
    }
  },
  created() {

    isDebug && console.log("[c회원선택] created()")
    ui = this.$ui, _=this._

    isDebug && console.log("[c회원선택] created_pop", this.search);
  },
  methods : {
    open(caseGubun, defaultKword, sellDt, cntchargdt, forceSelect = false) {
      this.list = _.cloneDeep(this.list_init) // 데이터 초기화 (필수 )

      this.defaultKword = defaultKword
      this.caseGubun = caseGubun

      // 증표판매일
      this.search.selldt = sellDt || ''
      // 증표수임일이 없는 경우 증표판매일로, 증표판매일도 없을 경우 오늘 날짜로
      this.search.cntchargdt  = cntchargdt || sellDt || this.$moment().format("YYYYMMDD")
      this.forceSelect = forceSelect

      isDebug && console.log("[c회원선택] open() defaultKword = ", defaultKword, ", this.defaultKword = ", this.defaultKword);
      this.$modal.show(this.modalName); // opened() call
    },
    opened() {
      isDebug && console.log("[c회원선택] opened()")

      this.doInit({focusDelay: 200}) // 화면이 열리자 마자 포커스를 주게되면
                      // 부모에서 앤터키 눌러서 들어온 경우 앤터키가 전파되어 검색을 두번하게 된다.
                      // 그래서 200ms 이후에 포커스를 준다.

      // console.log("오픈 : "+ defaultKword)
      if (this.defaultKword) { // 키워드가 넘어온 경우
        // console.log("오픈1")
        this.search.kword = this.defaultKword
        this.doSearch('부모_키워드')
      } else if (['master', 'member'].includes(this.$store.state.session.user.type)) { // 마스터 또는 소속변호사인경우
        this.doSearch('조직원_바로검색')
      } else {
        // console.log("오픈2")
        this.search.kword = ''
      }

    },
    doInit ({focusDelay=1}) {
      isDebug && console.log("[c회원선택] doInit()");
      this.search.kword = ''
      // this.$refs.main.clear()
      setTimeout(()=>this.doInitFocus(), focusDelay)
    },
    doInitFocus() {
      // opened() 전에는 refs 가 없을 수 있다.
      if (this.$refs.kword && this.$refs.kword.$el) {
        if (this.$refs.kword.$el.focus) { this.$refs.kword.$el.focus(); return }
        this.$refs.kword.$el.getElementsByTagName("input")[0].focus()
      }
    },
    doClose () {
      this.$modal.hide(this.modalName);
    },
    doSearch(searchMode) {
      this.searchMode = searchMode
      isDebug && console.log("[c회원선택] doSearch : searchMode =", searchMode)
      // this.$refs.main.load()
      this.list.pageNo = 1
      this.getDataList()
    },
    getDataList () {

      let list = this.list
      list.loading = true

      // 소속변호사 검색여부
      const iv_memberyn = this.$store.state.session.user.officeclsf == 'D' ? 'N' // 공동사무소일경우 무조건 전체 검색
                         : this.org_mode ? 'Y' : 'N' // 그 외에는 원래 조건

      const params = {
        iv_pgsize     : list.pageSize,
        iv_page       : list.pageNo,
        iv_membnm     : this.search.kword,             // 회원명
        iv_selldt     : this.search.selldt      || '', // 증표판매일
        iv_cntchargdt : _.get(this.search, 'cntchargdt', '').replace(/-/g, ''), // 수임일
        // iv_memberyn   : this.search.memberyn    || '', // 소속변호사 검색여부
        iv_memberyn   : iv_memberyn, // 소속변호사 검색여부
        iv_ableyn     : this.search.ableyn || '', // 등록가능한 변호사만 보기
      }
      isDebug && console.log("[c회원선택] getDataList() params = ", params);

      ui.httpGetDetail('/proc/N_MEMB_LIST_MY_V03', params, // 한번이라도 소속 된적있으면 휴업이든 탈퇴든 수임사건상세내역에서는 계속 조회가 되어야함
        ret => {

        const {tot_rows} = ret.data.rs1[0]

        list.totalCount  = tot_rows;
        list.items       = ret.data.rs2

        if (tot_rows == 0){
          ui.toast("결과가 없습니다")
          if (this.searchMode == '부모_키워드') { // 부모창에서 키워드 검색으로 들어왔는데 결과가 없는경우
            this.doClose()
            this.$emit('no_first_result')
          }
        } else if (tot_rows == 1) { // 결과가 하나인 경우
          this.doClick(list.items[0])
        }
      })
    },
    doClick (itemMap, $event) { // 선택
      let item = _.cloneDeep(itemMap)
      const already = _.some(this.memblist, { membclsf: item.membclsf, membno: item.membno })

      if (already) {
        ui.notify(`이미 선택되어 있습니다 : ${ item.membnm }`)
        return
      }

      if (!this.forceSelect && item.memb_status != 'OK') {
        // ui.alert(item.memb_status, '오류', {type: 'error'})

        let alert_msg
        if (this.$store.state.session.user.officeclsf == 'J' || this.$store.state.session.user.officeclsf == 'D') {
          alert_msg = `${ item.membnm } 회원은 '수임일자(${ this.search.cntchargdt })' 당시 공동/합동법률사무소 소속이 아니었기 때문에 공동변호인으로 추가할 수 없습니다.`
        }  else if (this.org_mode) { // 조직변호사일때 메세지
          alert_msg = `${ item.membnm } 회원은 '수임일자(${ this.search.cntchargdt })' 당시 귀 법무법인의 소속이 아니었기 때문에 담당변호사로 추가할 수 없습니다.

만약 해당 회원을 담당변호사로 추가하고자 할 경우

해당 증표를 사용한 후, '증표 사용 내역 조회ㆍ수정' 메뉴를 통해 현재일자로 담당변호사 추가 지정을 할 수 있습니다.`
        } else { // 개인변호사일때 메세지
          alert_msg = `${ item.membnm } 회원은  '수임일자(${ this.search.cntchargdt })' 당시 개업 상태가 아니거나 [법무법인, 법무법인(유한), 공동/합동법률사무소] 소속이기 때문에 공동으로 수임할 수 없습니다.`
        }
        ui.alert(alert_msg, '확인안내', {type: 'error', width: 610})
        return
      }

      const ctrl_press = !!($event && $event.ctrlKey) // 컨트롤 클릭 여부 ( 컨트롤 클릭이면 창 안닫을라고 )

      // 담당회원정보 세팅
      item.chrgmembno = item.membno
      item.chrgmembnm = item.membnm

      // 법인회원	- 팝업 선택시 법인체크하는 폼일경우
      if (this.caseGubun == "B") {

        // 법인,유한,법무조합,합동또는 조합소속 체크 flag
        let check_flag = ["B", "C", "E", "J", "D"]

        if (check_flag.includes(item.blngmembclsf))  {

          if (item.blngmembclsf != "J" && item.blngmembclsf != "D") {

            // 법인회원 개인회원 조회시 개인 회원일경우
            if (item.blngmembclsf == item.membclsf || item.blngmembno == item.chrgmembno) {
              return ui.alert('변호사명을 입력하셔야 합니다.')
            }

           /*  item.membclsf = item.blngmembclsf
            item.membno   = item.blngmembno */
          }
          item.membnm   = `${item.chrgmembnm}${ T.wrap유한(item.blngmembnm) }`
        }
      }

      this.$emit("select", {...item})
      if (ctrl_press == false) // 컨트롤 클릭이 아니라면 close
        this.doClose()
    }
  }
}

</script>
<style scoped>
  table.v-data-table td { height: 36px !important; }
  .popup_wrap .tbl01 .td_sosoc { width:150px;}
  .popup_wrap .tbl01 .td_address { width:300px;}
  table.memb_select > tbody > tr.selected { background-color: #C2C2C2; }
  table.memb_select > tbody > tr > td { color: black;}
  table.memb_select > tbody > tr.error > td { color: #a7a7a7;  }
</style>
